// extracted by mini-css-extract-plugin
export var camera = "ProfileImage_camera__X0NVo";
export var imageContainer = "ProfileImage_imageContainer__6nE8h";
export var lg = "992px";
export var md = "768px";
export var profileImage = "ProfileImage_profileImage__8gxaX";
export var shared = "\"../shared.module.css\"";